export const tenant = 'estradi';
const { config } = require('src/app/tenants/estradi/config')
export const siteConfig = config;